import { Accordion } from 'react-bootstrap'
import { IntegrationServiceId } from '../../../../common/integrations'
import './MappingTester.scss'

export interface IntegrationMappingTesterAccordionProps {
  serviceId: IntegrationServiceId
  testerComponents: React.FC<{ serviceId: IntegrationServiceId }>[]
  title: string
}

export const IntegrationMappingTesterAccordion: React.FC<IntegrationMappingTesterAccordionProps> = ({ serviceId, testerComponents, title }) => {
  return (
    <Accordion className='zocks-accordion-card'>
      <Accordion.Item eventKey='0' className='border-0'>
        <Accordion.Header className='bg-white'>
          <span className='fw-bold text-dark fs-5'>{title}</span>
        </Accordion.Header>
        <Accordion.Body className='bg-white p-4'>
          {testerComponents.map((Component, index) => (
            <div key={`tester-${index}`} className={index > 0 ? 'zocks-mt-2.0' : ''}>
              <Component serviceId={serviceId} />
            </div>
          ))}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}
